function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Created by pzf on 18/9/1.
 *
 */
import PropTypes from 'prop-types';
import noop from '../_util/noop'; // string | string[] | number | number[] | LabeledValue | LabeledValue[];

export function valueType(props, propName, componentName) {
  var basicType = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]);

  if (props.multiple && props[propName] === '') {
    return new Error("Invalid prop `".concat(propName, "` of type `string` supplied to `").concat(componentName, "`, ") + 'expected `array` when `multiple`');
  } else {
    var validate = PropTypes.oneOfType([PropTypes.arrayOf(basicType), basicType]);
    return validate.apply(void 0, arguments);
  }
} // 公共部分

export var commonPropTypes = {
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.array, // 支持两种数据赋值方式，直接赋值或lazyLoad
  PropTypes.object]),
  size: PropTypes.string,
  theme: PropTypes.string,
  value: valueType,
  lazyLoad: PropTypes.bool,
  icon: PropTypes.element,
  api: PropTypes.func,
  // 异步加载时会用到
  allowClear: PropTypes.bool,
  tagClosable: PropTypes.bool
}; // 公共部分

export var commonDefaultPropTypes = {
  placeholder: '',
  onChange: noop,
  disabled: false,
  multiple: false,
  data: [],
  lazyLoad: true,
  icon: null,
  api: noop,
  allowClear: true,
  tagClosable: true
};
export var popEditPropTypes = _extends(commonPropTypes, {
  inputClassName: PropTypes.string
});
export var popEditDefaultPropTypes = _extends(commonDefaultPropTypes);
//# sourceMappingURL=PropTypes.js.map
